<template lang="pug">
  .field
    label.label Seleccionar Autotanque
    .control
      .select.is-primary
        select(v-model="autotanqueSelected" @change="getDataPG")
          option(v-for="data in autotanques" :value="data.pg" :key="data.id")
            | {{ data.pg }}
</template>

<script>
import autotanquesServicesIRGE from '@/services/irge/autotanquesIRGE.js'

export default {
  name: 'SelectAutotanque',
  data () {
    return {
      autotanques: [],
      autotanqueSelected: ''
    }
  },
  props: {
    auto: { type: Object }
  },
  methods: {
    obtenerAutos () {
      autotanquesServicesIRGE.searchPG_All()
        .then(res => {
          console.log(res)
          this.autotanques = res
        })
    },
    getDataPG () {
      this.$emit('select', this.autotanqueSelected)
    }
  },
  created () {
    this.obtenerAutos()
  }
}
</script>




// WEBPACK FOOTER //
// src/components/sca_Componentes/acceso/SelectAutotanque.vue